import * as React from "react";

import { ConfirmationDialog } from "@/components/ConfirmationDialog";

interface DeletePropertyModalProps {
  open: boolean;
  onClose: () => void;
  onClickDelete: () => Promise<void>;
}

export const DeletePropertyModal: React.FC<DeletePropertyModalProps> = ({ open, onClose, onClickDelete }) => {
  const handleClickOutside = React.useCallback(() => {
    document.body.style.overflow = "auto"; // Enable scrolling
    onClose();
  }, [onClose]);

  // スクロール制御
  React.useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden"; // Disable scroll when modal is open
      return () => {
        document.body.style.overflow = "auto"; // Enable scroll when modal is closed
      };
    }
  }, [open]);

  const handleDelete = React.useCallback(() => {
    onClickDelete();
  }, [onClickDelete]);

  if (!open) return null;

  return (
    <ConfirmationDialog
      title="本当に削除しますか？"
      description={
        <>
          削除した物件は復元できません。
          <br /> 本当に削除しますか？
        </>
      }
      destructive
      confirmLabel="削除する"
      cancelLabel="キャンセル"
      onConfirm={handleDelete}
      onCancel={onClose}
      onClickOutside={handleClickOutside}
    />
  );
};
